export default {"src":"/polygon/_next/static/media/delta.3711433d.svg","height":48,"width":48};